// Generated by tools/build_mascot_art.py: the adult Dugzi, library v6 (brain mascot-current-v6).
// Each scene: AVIF and WebP at 320 and 640 px wide, and a 320 px palette PNG fallback.
// Astro imports images as objects with `src`; Vite as URL strings. `url` accepts both.

import greetingAvif320 from './assets/mascot/v6/greeting-320.avif';
import greetingAvif640 from './assets/mascot/v6/greeting-640.avif';
import greetingWebp320 from './assets/mascot/v6/greeting-320.webp';
import greetingWebp640 from './assets/mascot/v6/greeting-640.webp';
import greetingPng320 from './assets/mascot/v6/greeting-320.png';
import plannerAvif320 from './assets/mascot/v6/planner-320.avif';
import plannerAvif640 from './assets/mascot/v6/planner-640.avif';
import plannerWebp320 from './assets/mascot/v6/planner-320.webp';
import plannerWebp640 from './assets/mascot/v6/planner-640.webp';
import plannerPng320 from './assets/mascot/v6/planner-320.png';
import filingAvif320 from './assets/mascot/v6/filing-320.avif';
import filingAvif640 from './assets/mascot/v6/filing-640.avif';
import filingWebp320 from './assets/mascot/v6/filing-320.webp';
import filingWebp640 from './assets/mascot/v6/filing-640.webp';
import filingPng320 from './assets/mascot/v6/filing-320.png';
import creatingAvif320 from './assets/mascot/v6/creating-320.avif';
import creatingAvif640 from './assets/mascot/v6/creating-640.avif';
import creatingWebp320 from './assets/mascot/v6/creating-320.webp';
import creatingWebp640 from './assets/mascot/v6/creating-640.webp';
import creatingPng320 from './assets/mascot/v6/creating-320.png';
import tasksAvif320 from './assets/mascot/v6/tasks-320.avif';
import tasksAvif640 from './assets/mascot/v6/tasks-640.avif';
import tasksWebp320 from './assets/mascot/v6/tasks-320.webp';
import tasksWebp640 from './assets/mascot/v6/tasks-640.webp';
import tasksPng320 from './assets/mascot/v6/tasks-320.png';
import peopleAvif320 from './assets/mascot/v6/people-320.avif';
import peopleAvif640 from './assets/mascot/v6/people-640.avif';
import peopleWebp320 from './assets/mascot/v6/people-320.webp';
import peopleWebp640 from './assets/mascot/v6/people-640.webp';
import peoplePng320 from './assets/mascot/v6/people-320.png';
import mailAvif320 from './assets/mascot/v6/mail-320.avif';
import mailAvif640 from './assets/mascot/v6/mail-640.avif';
import mailWebp320 from './assets/mascot/v6/mail-320.webp';
import mailWebp640 from './assets/mascot/v6/mail-640.webp';
import mailPng320 from './assets/mascot/v6/mail-320.png';
import publishingAvif320 from './assets/mascot/v6/publishing-320.avif';
import publishingAvif640 from './assets/mascot/v6/publishing-640.avif';
import publishingWebp320 from './assets/mascot/v6/publishing-320.webp';
import publishingWebp640 from './assets/mascot/v6/publishing-640.webp';
import publishingPng320 from './assets/mascot/v6/publishing-320.png';
import movingAvif320 from './assets/mascot/v6/moving-320.avif';
import movingAvif640 from './assets/mascot/v6/moving-640.avif';
import movingWebp320 from './assets/mascot/v6/moving-320.webp';
import movingWebp640 from './assets/mascot/v6/moving-640.webp';
import movingPng320 from './assets/mascot/v6/moving-320.png';
import helloAvif320 from './assets/mascot/v6/hello-320.avif';
import helloAvif640 from './assets/mascot/v6/hello-640.avif';
import helloWebp320 from './assets/mascot/v6/hello-320.webp';
import helloWebp640 from './assets/mascot/v6/hello-640.webp';
import helloPng320 from './assets/mascot/v6/hello-320.png';
import restingAvif320 from './assets/mascot/v6/resting-320.avif';
import restingAvif640 from './assets/mascot/v6/resting-640.avif';
import restingWebp320 from './assets/mascot/v6/resting-320.webp';
import restingWebp640 from './assets/mascot/v6/resting-640.webp';
import restingPng320 from './assets/mascot/v6/resting-320.png';
import arriveAvif320 from './assets/mascot/v6/arrive-320.avif';
import arriveAvif640 from './assets/mascot/v6/arrive-640.avif';
import arriveWebp320 from './assets/mascot/v6/arrive-320.webp';
import arriveWebp640 from './assets/mascot/v6/arrive-640.webp';
import arrivePng320 from './assets/mascot/v6/arrive-320.png';

const url = (asset: string | { src: string }) => (typeof asset === 'string' ? asset : asset.src);

export const SCENE_ART = {
  greeting: { avif: `${url(greetingAvif320)} 320w, ${url(greetingAvif640)} 640w`, webp: `${url(greetingWebp320)} 320w, ${url(greetingWebp640)} 640w`, src: url(greetingPng320), width: 640, height: 1153 },
  planner: { avif: `${url(plannerAvif320)} 320w, ${url(plannerAvif640)} 640w`, webp: `${url(plannerWebp320)} 320w, ${url(plannerWebp640)} 640w`, src: url(plannerPng320), width: 640, height: 1763 },
  filing: { avif: `${url(filingAvif320)} 320w, ${url(filingAvif640)} 640w`, webp: `${url(filingWebp320)} 320w, ${url(filingWebp640)} 640w`, src: url(filingPng320), width: 640, height: 1205 },
  creating: { avif: `${url(creatingAvif320)} 320w, ${url(creatingAvif640)} 640w`, webp: `${url(creatingWebp320)} 320w, ${url(creatingWebp640)} 640w`, src: url(creatingPng320), width: 640, height: 669 },
  tasks: { avif: `${url(tasksAvif320)} 320w, ${url(tasksAvif640)} 640w`, webp: `${url(tasksWebp320)} 320w, ${url(tasksWebp640)} 640w`, src: url(tasksPng320), width: 640, height: 1602 },
  people: { avif: `${url(peopleAvif320)} 320w, ${url(peopleAvif640)} 640w`, webp: `${url(peopleWebp320)} 320w, ${url(peopleWebp640)} 640w`, src: url(peoplePng320), width: 640, height: 509 },
  mail: { avif: `${url(mailAvif320)} 320w, ${url(mailAvif640)} 640w`, webp: `${url(mailWebp320)} 320w, ${url(mailWebp640)} 640w`, src: url(mailPng320), width: 640, height: 636 },
  publishing: { avif: `${url(publishingAvif320)} 320w, ${url(publishingAvif640)} 640w`, webp: `${url(publishingWebp320)} 320w, ${url(publishingWebp640)} 640w`, src: url(publishingPng320), width: 640, height: 1593 },
  moving: { avif: `${url(movingAvif320)} 320w, ${url(movingAvif640)} 640w`, webp: `${url(movingWebp320)} 320w, ${url(movingWebp640)} 640w`, src: url(movingPng320), width: 640, height: 1318 },
  hello: { avif: `${url(helloAvif320)} 320w, ${url(helloAvif640)} 640w`, webp: `${url(helloWebp320)} 320w, ${url(helloWebp640)} 640w`, src: url(helloPng320), width: 640, height: 1385 },
  resting: { avif: `${url(restingAvif320)} 320w, ${url(restingAvif640)} 640w`, webp: `${url(restingWebp320)} 320w, ${url(restingWebp640)} 640w`, src: url(restingPng320), width: 640, height: 885 },
  arrive: { avif: `${url(arriveAvif320)} 320w, ${url(arriveAvif640)} 640w`, webp: `${url(arriveWebp320)} 320w, ${url(arriveWebp640)} 640w`, src: url(arrivePng320), width: 640, height: 910 },
} as const;
